import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {EnvironmentService} from '../../services/environmentService';
import { PaymentWhiteLabelAdminAPI } from '../../services/wladmin/paymentWhiteLabelAdminAPI';

@inject(AuthService, UserMessageService, Router, PaymentWhiteLabelAdminAPI, EnvironmentService)
export class Payments {
    constructor(authService, userMessageService, router, api, envService) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.api = api;
        this.envService = envService;

    }

    activate(params) {
        this.dataList = null;
        this.count = null;
        this.limit = 10;
        this.page = 1;
        this.sortBy = "PAYMENT_DATE";
        this.sortDir = "DESC";

        this.user_id = params.user_id;

        this.load();


    }

    load() {
        this.api.getList(
            this.user_id,
            this.page,
            this.limit,
            this.sortBy,
            this.sortDir,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    saveLoadSuccess(data) {
        this.setData(data);


    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(data) {
        this.dataList = data.list;
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
    }



    columnClicked(name) {
        $( ".sorting" ).removeClass( "sorting_asc" );
        $( ".sorting" ).removeClass( "sorting_desc" );
        if (this.sortBy == name) {
            if (this.sortDir == "ASC")
            {
                this.sortDir = "DESC";
                $( "#"+name ).addClass( "sorting_desc" );
            }    
            else
            {
                this.sortDir = "ASC";
                $( "#"+name ).addClass( "sorting_asc" );
            }    
            this.load();
        } else {
            this.sortBy = name;
            this.sortDir = "DESC";
            $( "#"+name ).addClass( "sorting_desc" );
            this.load();
        }
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.dataList = null;
            this.load();
        }
    }

    next() {
        if (this.page < this.pages) {
            this.page++;
            this.dataList = null;
            this.load();
        }
    }

    showJsonObj(json){
        try
        {
            var obj = JSON.parse(json);
            this.jsonViewerContent.innerHTML = JSON.stringify(obj, undefined, 2);
        } catch(ex) {
            this.jsonViewerContent.innerHTML = json;
        }


        this.showJsonViewer = true;
    }

    closeJsonViewer() {
        this.showJsonViewer = false;
    }

}
